/**
 * Format a number into a compact notation with K/M/B/T suffixes
 * Always returns a maximum of 3 significant digits
 * 
 * @param {number} num - The number to format
 * @returns {string} The formatted number string
 */
export const shortNumber = (num) => {
  if (num < 1000) return num.toString();

  // Determine "power" for K/M/B/T
  const power = Math.floor(Math.log10(num) / 3);
  
  // Scale the number down
  const value = num / Math.pow(1000, power);

  // Decide fraction digits to ensure max 3 significant digits:
  // - If value is a whole number (like 14.0), use 0 decimals
  // - If value < 100 and has decimals, use 1 decimal
  // - If value >= 100, use 0 decimals
  let fractionDigits = 0;
  if (value < 100 && value % 1 !== 0) {
    fractionDigits = 1;
  }

  // Use Intl.NumberFormat for compact notation
  const formatter = new Intl.NumberFormat('en', {
    notation: 'compact',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

  return formatter.format(num);
};

